import {
  CookieKeys,
  getClientBooleanCookie,
  getClientCookie,
} from '@finn/ui-utils';
import { useEffect, useState } from 'react';

const useOnPLPMount = () => {
  const [isCarNotExist, setIsCarNotExist] = useState(false);
  const [isDealClosed, setIsDealClosed] = useState(false);
  const [isRedirectedPageNotExist, setIsRedirectedPageNotExist] =
    useState(false);

  useEffect(() => {
    // Set checkout redirect errors in the cookie
    const cartNotAvailable = getClientBooleanCookie(
      CookieKeys.VEHICLE_CART_NOT_AVAILABLE
    );
    setIsCarNotExist(cartNotAvailable);
    setIsRedirectedPageNotExist(
      getClientBooleanCookie(CookieKeys.PAGE_NOT_AVAILABLE)
    );

    const dealClosedCookieValue = getClientCookie(CookieKeys.DEAL_CLOSED);
    if (dealClosedCookieValue) {
      setIsDealClosed(true);
    }
  }, []);

  return { isCarNotExist, isRedirectedPageNotExist, isDealClosed };
};

export default useOnPLPMount;
